(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[94],{

/***/ 5835:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./AuthorLayout": 5269,
	"./AuthorLayout.tsx": 5269,
	"./PostLayout": 4570,
	"./PostLayout.tsx": 4570,
	"./PostSimple": 1959,
	"./PostSimple.tsx": 1959
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5835;

/***/ }),

/***/ 7484:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",$="Invalid Date",l=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},g={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},v="en",D={};D[v]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return v;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(v=i),i||!r&&v},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=g;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(l);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===$)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),$=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},l=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,g="set"+(this.$u?"UTC":"");switch(h){case c:return r?$(1,0):$(31,11);case f:return r?$(1,M):$(0,M+1);case o:var v=this.$locale().weekStart||0,D=(y<v?y+7:y)-v;return $(r?m-D:m+(6-D),M);case a:case d:return l(g+"Hours",0);case u:return l(g+"Minutes",1);case s:return l(g+"Seconds",2);case i:return l(g+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),$=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],l=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[$](l),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else $&&this.$d[$](l);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,$=this;r=Number(r);var l=O.p(h),y=function(t){var e=w($);return O.w(e.date(e.date()+Math.round(t*r)),$)};if(l===f)return this.set(f,this.$M+r);if(l===c)return this.set(c,this.$y+r);if(l===a)return y(1);if(l===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[l]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||$;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||l[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,$){var l,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,g=this-M,v=O.m(this,M);return v=(l={},l[c]=v/12,l[f]=v,l[h]=v/3,l[o]=(g-m)/6048e5,l[a]=(g-m)/864e5,l[u]=g/n,l[s]=g/e,l[i]=g/t,l)[y]||g,$?v:O.a(v)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[v],w.Ls=D,w.p={},w}));

/***/ }),

/***/ 3303:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[...slug]",
      function () {
        return __webpack_require__(8633);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ FAQSection; }
/* harmony export */ });
/* unused harmony export FAQ */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var components_library_IconButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1172);
/* harmony import */ var components_library_utils_classNames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5368);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4580);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6763);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);





const FAQSection = (param)=>{
    let { title ="Frequently asked questions" , questions  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "container-xl flex justify-center py-120 dark:bg-gray-900",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col items-center gap-y-48",
            children: [
                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "font-display text-32-40 font-bold text-gray-900 dark:text-white",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-col items-center divide-y divide-gray-400 dark:divide-gray-800",
                    children: questions.map((question)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FAQ, {
                            ...question
                        }, question.question))
                })
            ]
        })
    });
};
const FAQ = (param)=>{
    let { question , answer , defaultOpen  } = param;
    const [open, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(defaultOpen || false);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full py-12",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex w-full cursor-pointer items-center justify-between",
                onClick: ()=>setOpen((open)=>!open),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "max-w-prose text-16-24 font-bold text-gray-900 dark:text-white",
                        children: question
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_library_IconButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        size: 40,
                        shade: components_library_IconButton__WEBPACK_IMPORTED_MODULE_1__/* .IconButtonShade.Gray */ .f.Gray,
                        Icon: open ? _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z : _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
                        onClick: (event)=>{
                            event.stopPropagation();
                            return setOpen((open)=>!open);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,components_library_utils_classNames__WEBPACK_IMPORTED_MODULE_5__/* .classNames */ .A)("overflow-hidden", open ? "my-12 h-full" : "h-0"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "max-w-prose text-16-26 text-gray-800 child-a:underline child-a-hover:no-underline dark:text-gray-500",
                    children: answer
                })
            })
        ]
    });
};


/***/ }),

/***/ 6336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ Author; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
// This is a bit of mess with regards to the input.

const Author = (props)=>{
    const { author  } = props;
    let image;
    switch(author){
        case "Raza Habib":
            image = "/assets/headshots/raza.png";
            break;
        case "Jordan Burgess":
            image = "/assets/headshots/jordan.png";
            break;
        case "Peter Hayes":
            image = "/assets/headshots/peter.png";
            break;
        case "Harry Xie":
            image = "/assets/headshots/harry.png";
            break;
        case "Tom Keefe":
            image = "/assets/headshots/tom.png";
            break;
        case "Emine Yilmaz":
            image = "/assets/headshots/emine.png";
            break;
        case "David Barber":
            image = "/assets/headshots/david.png";
            break;
        default:
            image = "/assets/logs/padded.png";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex items-center gap-12",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex min-w-0 shrink items-center gap-16",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: " h-40 w-40 shrink-0 rounded-full bg-cover bg-center shadow-inner-border dark:shadow-none",
                    title: props.author,
                    style: {
                        backgroundImage: "url(".concat(image, ")")
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-14-20 text-gray-700 dark:text-white",
                children: props.author
            })
        ]
    });
};


/***/ }),

/***/ 2150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ BlogTypeAndDate; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);


const BlogTypeAndDate = (param)=>{
    let { type , date  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("aside", {
        className: "flex items-center gap-12 text-14-20",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                className: "sr-only",
                children: "Blog post type"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "font-bold text-blue-500 dark:text-yellow-500",
                children: type || "Blog"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-4 w-4 rounded-full bg-gray-300 dark:bg-gray-600"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                className: "sr-only",
                children: "Published on"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", {
                    className: "text-gray-800 dark:text-gray-500",
                    dateTime: date,
                    children: dayjs__WEBPACK_IMPORTED_MODULE_1___default()(date).format("MMMM D, YYYY")
                })
            })
        ]
    });
};


/***/ }),

/***/ 6378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* eslint-disable jsx-a11y/anchor-has-content */ 

const CustomLink = (param)=>{
    let { href , ...rest } = param;
    const isInternalLink = href && href.startsWith("/");
    const isAnchorLink = href && href.startsWith("#");
    if (isInternalLink) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: href,
            legacyBehavior: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: href,
                ...rest
            })
        });
    }
    if (isAnchorLink) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            ...rest
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: href,
        ...rest
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomLink);


/***/ }),

/***/ 5125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$t": function() { return /* binding */ TagSEO; },
/* harmony export */   "TQ": function() { return /* binding */ PageSEO; },
/* harmony export */   "Uy": function() { return /* binding */ BlogSEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _data_siteMetadata__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1576);
/* harmony import */ var _data_siteMetadata__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_data_siteMetadata__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_4__);





const CommonSEO = (param)=>{
    let { title , description , ogType , ogImage , twImage , canonicalUrl  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "follow, index"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: "".concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_1___default().siteUrl)).concat(router.asPath)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: ogType
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_1___default().title)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            Array.isArray(ogImage) ? ogImage.map((param)=>/*#__PURE__*/ {
                let { url  } = param;
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: url
                }, url);
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: ogImage
            }, ogImage),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_1___default().twitter)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: twImage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl ? canonicalUrl : "".concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_1___default().siteUrl)).concat(router.asPath)
            })
        ]
    });
};
const PageSEO = (param)=>{
    let { title , description , image  } = param;
    const ogImageUrl = (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_1___default().siteUrl) + image || (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_1___default().socialBanner);
    const twImageUrl = (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_1___default().siteUrl) + image || (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_1___default().socialBanner);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CommonSEO, {
        title: title,
        description: description,
        ogType: "website",
        ogImage: ogImageUrl,
        twImage: twImageUrl
    });
};
const TagSEO = (param)=>{
    let { title , description  } = param;
    const ogImageUrl = (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_1___default().siteUrl) + (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_1___default().socialBanner);
    const twImageUrl = (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_1___default().siteUrl) + (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_1___default().socialBanner);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CommonSEO, {
                title: title,
                description: description,
                ogType: "website",
                ogImage: ogImageUrl,
                twImage: twImageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "alternate",
                    type: "application/rss+xml",
                    title: "".concat(description, " - RSS feed"),
                    href: "".concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_1___default().siteUrl)).concat(router.asPath, "/feed.xml")
                })
            })
        ]
    });
};
const BlogSEO = (param)=>{
    let { authorDetails , title , summary , date , lastmod , url , images =[] , thumbnail , canonicalUrl  } = param;
    const publishedAt = new Date(date).toISOString();
    const modifiedAt = new Date(lastmod || date).toISOString();
    const imagesArr = thumbnail ? [
        thumbnail
    ] : [
        (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_1___default().socialBanner)
    ];
    const featuredImages = imagesArr.map((img)=>{
        return {
            "@type": "ImageObject",
            url: "".concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_1___default().siteUrl)).concat(img)
        };
    });
    let authorList;
    if (authorDetails) {
        authorList = authorDetails.map((author)=>{
            return {
                "@type": "Person",
                name: author.name
            };
        });
    } else {
        authorList = {
            "@type": "Person",
            name: (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_1___default().author)
        };
    }
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "Article",
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": url
        },
        headline: title,
        image: featuredImages,
        datePublished: publishedAt,
        dateModified: modifiedAt,
        author: authorList,
        publisher: {
            "@type": "Organization",
            name: (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_1___default().author),
            logo: {
                "@type": "ImageObject",
                url: "".concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_1___default().siteUrl)).concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_1___default().siteLogo))
            }
        },
        description: summary
    };
    const twImageUrl = featuredImages[0].url;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CommonSEO, {
                title: title,
                description: summary,
                ogType: "article",
                ogImage: featuredImages,
                twImage: twImageUrl,
                canonicalUrl: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    date && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "article:published_time",
                        content: publishedAt
                    }),
                    lastmod && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "article:modified_time",
                        content: modifiedAt
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_4___default()), {
                id: "structured-data-script",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(structuredData, null, 2)
                }
            })
        ]
    });
};


/***/ }),

/***/ 5269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ AuthorLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_blog_SEO__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5125);



function AuthorLayout(param) {
    let { children , frontMatter  } = param;
    const { name , avatar , occupation , company , email , twitter , linkedin , github  } = frontMatter;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_blog_SEO__WEBPACK_IMPORTED_MODULE_2__/* .PageSEO */ .TQ, {
                title: "About - ".concat(name),
                description: "About me - ".concat(name)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "divide-y",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "md:space-y-5 space-y-2 pt-6 pb-8",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "md:text-6xl text-32-36 font-extrabold leading-9 tracking-tight text-gray-900 dark:text-gray-100 sm:text-56-56 sm:leading-10 md:leading-14",
                            children: "About"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "items-start space-y-2 xl:grid xl:grid-cols-3 xl:gap-x-8 xl:space-y-0",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col items-center space-x-2 pt-8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: avatar,
                                        alt: "avatar",
                                        width: 192,
                                        height: 192,
                                        className: "h-48 w-48 rounded-full"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "pt-4 pb-2 text-28-32 font-bold leading-8 tracking-tight",
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-gray-500 dark:text-gray-400",
                                        children: occupation
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-gray-500 dark:text-gray-400",
                                        children: company
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "space-x-3 flex pt-6"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "prose max-w-none pt-8 pb-8 dark:prose-dark xl:col-span-2",
                                children: children
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 4570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ PostLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./data/siteMetadata.js
var siteMetadata = __webpack_require__(1576);
var siteMetadata_default = /*#__PURE__*/__webpack_require__.n(siteMetadata);
// EXTERNAL MODULE: ./components/library/Button.tsx + 1 modules
var Button = __webpack_require__(1317);
// EXTERNAL MODULE: ./hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(7921);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/blog/AuthorSection.tsx




const AuthorSection = (param)=>{
    let { author  } = param;
    const { isSmallWidth , isMediumWidth  } = (0,useBreakpoints/* useBreakpoints */.k)();
    let imageWidth;
    if (!isSmallWidth) {
        imageWidth = 96;
    } else if (!isMediumWidth) {
        imageWidth = 160;
    } else {
        imageWidth = 290;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "dark bg-black pb-32 md:pb-[52px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container-xl md:py-52",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "flex py-40 text-14-16 font-bold dark:text-white",
                    children: "About the author"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-24 md:justify-center md:gap-40",
                    children: [
                        author.avatar && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: author.avatar,
                            width: imageWidth,
                            height: imageWidth,
                            alt: "avatar",
                            className: "flex-none"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "max-w-md",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                            className: "sr-only",
                                            children: "Name"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                            className: "font-display text-24-32 font-bold text-gray-900 dark:text-white",
                                            children: author.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                            className: "sr-only",
                                            children: "Role"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                            className: "mt-4 text-14-20 font-bold text-gray-900 dark:text-gray-600",
                                            children: author.occupation
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-24 hidden text-14-24 dark:text-white md:block",
                                    children: author.bio
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                    className: "",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                            className: "sr-only",
                                            children: "Twitter"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                            children: author.twitter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                styling: "link",
                                                href: author.twitter,
                                                target: "_blank",
                                                className: "-ml-12 mt-12",
                                                children: author.twitter.replace("https://twitter.com/", "@")
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-24 text-13-20 dark:text-white md:hidden md:text-14-24",
                    children: author.bio
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/blog/Author.tsx
var Author = __webpack_require__(6336);
// EXTERNAL MODULE: ./components/blog/BlogTypeAndDate.tsx
var BlogTypeAndDate = __webpack_require__(2150);
;// CONCATENATED MODULE: ./public/assets/documentary/laptop-hands-unsplash.jpg
/* harmony default export */ var laptop_hands_unsplash = ({"src":"/_next/static/media/laptop-hands-unsplash.ab43df13.jpg","height":1600,"width":2400,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAeEAACAQQDAQAAAAAAAAAAAAABAwACBBExBRMiUf/EABQBAQAAAAAAAAAAAAAAAAAAAAH/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCCdaWreBferQEOS00nrPmrBwDg639iIiH/2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./components/blog/BlogPostHero.tsx





const BlogPostHero = (param)=>{
    let { post , authors  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "dark bg-black",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-240 w-full grow md:mx-0 md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative h-full w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: post.thumbnail || laptop_hands_unsplash,
                        alt: "",
                        layout: "fill",
                        objectFit: "contain",
                        priority: true
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container-xl flex gap-32 py-32 md:gap-40 md:pt-[52px] md:pb-[52px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col justify-between gap-12 md:w-2/5 md:min-w-[380px] lg:min-w-[520px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogTypeAndDate/* BlogTypeAndDate */.o, {
                                type: post.type,
                                date: post.date
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "flex flex-col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col gap-y-24",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "font-display text-32-36 text-gray-900 dark:text-white sm:text-56-56 ",
                                            children: post.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: authors.map((author)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Author/* Author */.S, {
                                                    author: author.name
                                                }, author.name))
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden min-h-[468px] w-full grow md:mx-0 md:block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative h-full w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: post.thumbnail || laptop_hands_unsplash,
                                alt: "",
                                layout: "fill",
                                objectFit: "contain",
                                objectPosition: "right"
                            })
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/blog/SEO.tsx
var SEO = __webpack_require__(5125);
;// CONCATENATED MODULE: ./components/blog/layouts/PostLayout.tsx






const twitterDiscussionUrl = (slug)=>"https://mobile.twitter.com/search?q=".concat(encodeURIComponent("".concat((siteMetadata_default()).siteUrl, "/blog/").concat(slug)));
const postDateTemplate = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
};
function PostLayout(param) {
    let { frontMatter , authorDetails , children  } = param;
    const { slug  } = frontMatter;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* BlogSEO */.Uy, {
                url: "".concat((siteMetadata_default()).siteUrl, "/blog/").concat(slug),
                authorDetails: authorDetails,
                ...frontMatter
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogPostHero, {
                        post: frontMatter,
                        authors: authorDetails
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container-xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative overflow-hidden bg-white pt-48 pb-[108px] sm:pt-80",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "prose prose-blue mx-auto text-gray-800",
                                    children: children
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mx-auto my-40 max-w-prose",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        href: twitterDiscussionUrl(slug),
                                        rel: "nofollow",
                                        styling: "link",
                                        children: "Discuss on Twitter"
                                    }),
                                    frontMatter.hackernews && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        href: frontMatter.hackernews,
                                        rel: "nofollow",
                                        styling: "link",
                                        children: "Join the discussion on Hacker News"
                                    })
                                ]
                            })
                        ]
                    }),
                    authorDetails.map((author)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(AuthorSection, {
                            author: author
                        }, author.name))
                ]
            })
        ]
    });
}


/***/ }),

/***/ 1959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ PostSimple; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/blog/Link.tsx
var Link = __webpack_require__(6378);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/blog/ScrollTopAndComment.tsx


const ScrollTopAndComment = ()=>{
    const [show, setShow] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const handleWindowScroll = ()=>{
            if (window.scrollY > 50) setShow(true);
            else setShow(false);
        };
        window.addEventListener("scroll", handleWindowScroll);
        return ()=>window.removeEventListener("scroll", handleWindowScroll);
    }, []);
    const handleScrollTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    const handleScrollToComment = ()=>{
        var ref;
        (ref = document === null || document === void 0 ? void 0 : document.getElementById("comment")) === null || ref === void 0 ? void 0 : ref.scrollIntoView();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "gap-3 fixed right-8 bottom-8 hidden flex-col ".concat(show ? "md:flex" : "md:hidden"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": "Scroll To Comment",
                type: "button",
                onClick: handleScrollToComment,
                className: "rounded-full bg-gray-200 p-2 text-gray-500 transition-all hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-400 dark:hover:bg-gray-600",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    className: "h-5 w-5",
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z",
                        clipRule: "evenodd"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": "Scroll To Top",
                type: "button",
                onClick: handleScrollTop,
                className: "rounded-full bg-gray-200 p-2 text-gray-500 transition-all hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-400 dark:hover:bg-gray-600",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    className: "h-5 w-5",
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M3.293 9.707a1 1 0 010-1.414l6-6a1 1 0 011.414 0l6 6a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L4.707 9.707a1 1 0 01-1.414 0z",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var blog_ScrollTopAndComment = (ScrollTopAndComment);

// EXTERNAL MODULE: ./components/blog/SEO.tsx
var SEO = __webpack_require__(5125);
// EXTERNAL MODULE: ./data/siteMetadata.js
var siteMetadata = __webpack_require__(1576);
var siteMetadata_default = /*#__PURE__*/__webpack_require__.n(siteMetadata);
;// CONCATENATED MODULE: ./lib/utils/formatDate.ts

const formatDate = (date)=>{
    const options = {
        year: "numeric",
        month: "long",
        day: "numeric"
    };
    const now = new Date(date).toLocaleDateString((siteMetadata_default()).locale, options);
    return now;
};
/* harmony default export */ var utils_formatDate = (formatDate);

;// CONCATENATED MODULE: ./components/blog/layouts/PostSimple.tsx






function PostSimple(param) {
    let { frontMatter , next , prev , children  } = param;
    const { slug , date , title  } = frontMatter;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* BlogSEO */.Uy, {
                url: "".concat((siteMetadata_default()).siteUrl, "/blog/").concat(slug),
                ...frontMatter
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_ScrollTopAndComment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "space-y-1 border-b border-gray-200 pb-10 text-center dark:border-gray-700",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                    className: "sr-only",
                                                    children: "Published on"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                    className: "font-medium text-base leading-6 text-gray-500 dark:text-gray-400",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                                        dateTime: date,
                                                        children: utils_formatDate(date)
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            children: title
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "divide-y divide-gray-200 pb-8 dark:divide-gray-700 xl:divide-y-0 ",
                            style: {
                                gridTemplateRows: "auto 1fr"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "divide-y divide-gray-200 dark:divide-gray-700 xl:col-span-3 xl:row-span-2 xl:pb-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "prose max-w-none pt-10 pb-8 dark:prose-dark",
                                        children: children
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "font-medium flex flex-col text-14-16 sm:flex-row sm:justify-between sm:text-base",
                                        children: [
                                            prev && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "pt-4 xl:pt-8",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                                    href: "/blog/".concat(prev.slug),
                                                    className: "text-primary-500 hover:text-primary-600 dark:hover:text-primary-400",
                                                    children: [
                                                        "← ",
                                                        prev.title
                                                    ]
                                                })
                                            }),
                                            next && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "pt-4 xl:pt-8",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                                    href: "/blog/".concat(next.slug),
                                                    className: "text-primary-500 hover:text-primary-600 dark:hover:text-primary-400",
                                                    children: [
                                                        next.title,
                                                        " →"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 7492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ FourZeroFour; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_blog_Link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6378);
/* harmony import */ var components_library_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1317);



function FourZeroFour() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col items-start justify-start md:mt-60 md:flex-row md:items-center md:justify-center md:space-x-36",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pb-42 space-x-8 pt-36 md:space-y-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "text-6xl md:text-8xl font-bold leading-9 tracking-tight text-gray-900 dark:text-gray-100 md:px-36 ",
                    children: "404"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-md",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mb-16 text-24-28 font-bold leading-normal md:text-28-32",
                        children: "Sorry we couldn't find this page."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mb-16",
                        children: "But don't worry, you can find plenty of other things on our homepage."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_blog_Link__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        href: "/",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_library_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            children: "Back to homepage"
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 8633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/mdx-bundler/client/index.js
var client = __webpack_require__(3194);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/blog/Link.tsx
var Link = __webpack_require__(6378);
;// CONCATENATED MODULE: ./components/blog/TOCInline.tsx

/**
 * Generates an inline table of contents
 * Exclude titles matching this string (new RegExp('^(' + string + ')$', 'i')).
 * If an array is passed the array gets joined with a pipe (new RegExp('^(' + array.join('|') + ')$', 'i')).
 *
 * @param {TOCInlineProps} {
 *   toc,
 *   indentDepth = 3,
 *   fromHeading = 1,
 *   toHeading = 6,
 *   asDisclosure = false,
 *   exclude = '',
 * }
 *
 */ const TOCInline = (param)=>{
    let { toc , indentDepth =3 , fromHeading =1 , toHeading =6 , asDisclosure =false , exclude =""  } = param;
    const re = Array.isArray(exclude) ? new RegExp("^(" + exclude.join("|") + ")$", "i") : new RegExp("^(" + exclude + ")$", "i");
    const filteredToc = toc.filter((heading)=>heading.depth >= fromHeading && heading.depth <= toHeading && !re.test(heading.value));
    const tocList = /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        children: filteredToc.map((heading)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "".concat(heading.depth >= indentDepth && "ml-6"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: heading.url,
                    children: heading.value
                })
            }, heading.value))
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: asDisclosure ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("details", {
            open: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("summary", {
                    className: "ml-6 pt-2 pb-2 text-24-28 font-bold",
                    children: "Table of Contents"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "ml-6",
                    children: tocList
                })
            ]
        }) : tocList
    });
};
/* harmony default export */ var blog_TOCInline = (TOCInline);

;// CONCATENATED MODULE: ./components/blog/Pre.tsx


const Pre = (param)=>{
    let { children  } = param;
    const textInput = (0,react.useRef)(null);
    const [hovered, setHovered] = (0,react.useState)(false);
    const [copied, setCopied] = (0,react.useState)(false);
    const onEnter = ()=>{
        setHovered(true);
    };
    const onExit = ()=>{
        setHovered(false);
        setCopied(false);
    };
    const onCopy = ()=>{
        setCopied(true);
        if (textInput.current === null || textInput.current.textContent === null) {
            console.log("No text input to copy.");
            return;
        }
        navigator.clipboard.writeText(textInput.current.textContent);
        setTimeout(()=>{
            setCopied(false);
        }, 2000);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: textInput,
        onMouseEnter: onEnter,
        onMouseLeave: onExit,
        className: "relative",
        children: [
            hovered && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": "Copy code",
                type: "button",
                className: "absolute right-2 top-2 h-8 w-8 rounded border-2 bg-gray-700 p-1 dark:bg-gray-800 ".concat(copied ? "border-green-400 focus:border-green-400 focus:outline-none" : "border-gray-300"),
                onClick: onCopy,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                    fill: "none",
                    className: copied ? "text-green-400" : "text-gray-300",
                    children: copied ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                children: children
            })
        ]
    });
};
/* harmony default export */ var blog_Pre = (Pre);

// EXTERNAL MODULE: ./components/library/Button.tsx + 1 modules
var Button = __webpack_require__(1317);
// EXTERNAL MODULE: ./components/library/Logos.tsx
var Logos = __webpack_require__(6786);
// EXTERNAL MODULE: ./components/FAQSection.tsx
var FAQSection = __webpack_require__(3632);
// EXTERNAL MODULE: ./components/library/utils/classNames.ts
var classNames = __webpack_require__(5368);
// EXTERNAL MODULE: ./components/platform/NewsletterSignUp.tsx
var NewsletterSignUp = __webpack_require__(3360);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/MailIcon.js
var MailIcon = __webpack_require__(9700);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(4931);
// EXTERNAL MODULE: ./services/analytics.service.ts
var analytics_service = __webpack_require__(2554);
// EXTERNAL MODULE: ./services/api.service.ts + 1 modules
var api_service = __webpack_require__(1506);
// EXTERNAL MODULE: ./components/library/Icons.tsx
var Icons = __webpack_require__(4305);
;// CONCATENATED MODULE: ./components/blog/GPT3SignUp.tsx









// Copy of NewsletterSignUp pointing to different form
const GPT3SignUp = (param)=>{
    let { shade  } = param;
    const buttonText = "Request Access";
    const [loading, setLoading] = (0,react.useState)(false);
    const [form, setForm] = (0,react.useState)({
        email: ""
    });
    const [signedUp, setSignedUp] = (0,react.useState)(false);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setLoading(true);
        analytics_service/* Analytics.identify */.cp.identify(form.email, {
            email: form.email
        });
        analytics_service/* Analytics.track */.cp.track(analytics_service/* EventObject.Form */.fC.Form, analytics_service/* EventAction.Submitted */.AO.Submitted, {
            form: "gpt3-signup",
            email: form.email
        });
        try {
            const result = await api_service/* ApiService.post */.s.post("/api/gpt3-signup", form, {}, (e, method, url, data, config)=>{
                var ref, ref1;
                const message = e === null || e === void 0 ? void 0 : (ref = e.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message;
                console.log("Failed to fetch:", e, method, url, data, config);
                if (message) {
                    react_hot_toast_esm/* default.error */.ZP.error(message);
                }
            });
            if (result.status === 200) {
                setSignedUp(true);
            }
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-16 sm:min-w-[350px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-14-20 text-gray-600",
                children: "Request access to the Humanloop closed beta"
            }),
            signedUp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border-b border-gray-400",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex h-[44px] items-center py-8 text-14-20 text-gray-800 md:h-52",
                    children: "Request received! We'll get in touch shortly."
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                onSubmit: handleSubmit,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center gap-12 border-b border-gray-400",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative grow rounded",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MailIcon/* default */.Z, {
                                    className: "h-24 w-24 text-gray-400",
                                    "aria-hidden": "true"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "email",
                                name: "email",
                                id: "email",
                                required: true,
                                className: "form-input block h-[44px] w-full border-0 pl-48 pr-[140px] text-14-20 text-black ring-0 focus:ring-0 md:h-52",
                                placeholder: "your email",
                                value: form.email,
                                onChange: (e)=>{
                                    setForm({
                                        ...form,
                                        email: e.target.value
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-y-0 right-0 flex items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    type: "submit",
                                    styling: "ghost",
                                    shade: Button/* ButtonShade.Gray */.B.Gray,
                                    className: (0,classNames/* classNames */.A)(shade === "black" && "!bg-black", "whitespace-nowrap", loading ? "pl-20 pr-16" : "px-32", "!font-normal"),
                                    square: true,
                                    loading: loading,
                                    IconRight: loading ? Icons/* LoadingIcon */.Ho : undefined,
                                    size: 40,
                                    children: buttonText
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var blog_GPT3SignUp = (GPT3SignUp);

;// CONCATENATED MODULE: ./components/blog/MDXComponents.tsx













const Wrapper = (param)=>{
    let { layout , ...rest } = param;
    const Layout = __webpack_require__(5835)("./".concat(layout)).default;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
        ...rest
    });
};
const Sm2Columns = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classNames/* classNames */.A)("grid sm:grid-cols-2 sm:gap-x-32", className),
        children: children
    });
};
const Caption = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classNames/* classNames */.A)("not-prose -mt-4 text-13-16 leading-[20px] text-gray-800 dark:text-gray-100", className),
        children: children
    });
};
// Use this mapper to set custom components for the rendered HTML
// e.g. h1: PageTitle , h2: SmallHeader etc.
const MDXComponents = {
    // eslint-disable-next-line jsx-a11y/alt-text
    Image: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            ...props,
            lazyBoundary: "600px"
        }),
    Sm2Columns,
    TOCInline: blog_TOCInline,
    Caption,
    a: Link/* default */.Z,
    NotProse: (param)=>/*#__PURE__*/ {
        let { className , children  } = param;
        return (0,jsx_runtime.jsx)("div", {
            className: (0,classNames/* classNames */.A)("not-prose", className),
            children: children
        });
    },
    InitialParagraph: (param)=>/*#__PURE__*/ {
        let { className , ...props } = param;
        return (0,jsx_runtime.jsx)("div", {
            className: (0,classNames/* classNames */.A)("not-prose text-16-26 text-gray-900 sm:text-18-28", className),
            children: props.children
        });
    },
    pre: blog_Pre,
    wrapper: Wrapper,
    Button: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "not-prose",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                ...props
            })
        }),
    HumanloopLogo: Logos/* HumanloopLogo */.k,
    FAQSection: FAQSection/* FAQSection */.v,
    NewsletterSignUp: NewsletterSignUp/* default */.Z,
    GPT3SignUp: blog_GPT3SignUp
};
const MDXLayoutRenderer = (param)=>{
    let { layout , mdxSource , ...rest } = param;
    const MDXLayout = (0,react.useMemo)(()=>(0,client.getMDXComponent)(mdxSource), [
        mdxSource
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MDXLayout, {
        layout: layout,
        components: MDXComponents,
        ...rest
    });
};

// EXTERNAL MODULE: ./components/platform/Layout.tsx + 2 modules
var Layout = __webpack_require__(8372);
// EXTERNAL MODULE: ./pages/404.tsx
var _404 = __webpack_require__(7492);
;// CONCATENATED MODULE: ./pages/blog/[...slug].tsx




const DEFAULT_LAYOUT = "PostLayout";
const Blog = (param)=>{
    let { post , authorDetails , prev , next  } = param;
    const { mdxSource , toc , frontMatter  } = post;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "draft" in frontMatter && frontMatter.draft !== true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MDXLayoutRenderer, {
            layout: frontMatter.layout || DEFAULT_LAYOUT,
            toc: toc,
            mdxSource: mdxSource,
            frontMatter: frontMatter,
            authorDetails: authorDetails,
            prev: prev,
            next: next
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(_404["default"], {})
    });
};
Blog.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        noTags: true,
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (Blog);


/***/ }),

/***/ 3194:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(8773)


/***/ }),

/***/ 8773:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.getMDXComponent = getMDXComponent;
__webpack_unused_export__ = getMDXExport;

var React = _interopRequireWildcard(__webpack_require__(7294));

var _jsx_runtime = _interopRequireWildcard(__webpack_require__(5893));

var ReactDOM = _interopRequireWildcard(__webpack_require__(3935));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * @typedef {import('mdx/types').MDXComponents} ComponentMap
 */

/**
 * @typedef {{[props: string]: unknown, components?: ComponentMap}} MDXContentProps
 */

/**
 *
 * @param {string} code - The string of code you got from bundleMDX
 * @param {Record<string, unknown>} [globals] - Any variables your MDX needs to have accessible when it runs
 * @return {React.FunctionComponent<MDXContentProps>}
 */
function getMDXComponent(code, globals) {
  const mdxExport = getMDXExport(code, globals);
  return mdxExport.default;
}
/**
 * @template ExportedObject
 * @template Frontmatter
 * @type {import('./types').MDXExportFunction<ExportedObject, Frontmatter>}
 * @param {string} code - The string of code you got from bundleMDX
 * @param {Record<string, unknown>} [globals] - Any variables your MDX needs to have accessible when it runs
 *
 */


function getMDXExport(code, globals) {
  const scope = {
    React,
    ReactDOM,
    _jsx_runtime,
    ...globals
  }; // eslint-disable-next-line

  const fn = new Function(...Object.keys(scope), code);
  return fn(...Object.values(scope));
}

/***/ }),

/***/ 4580:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


function MinusIcon(props, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20 12H4"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(MinusIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 6763:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


function PlusIcon(props, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 4v16m8-8H4"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(PlusIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,764,669,530,666,675,417,372,774,888,179], function() { return __webpack_exec__(3303); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);